var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonthChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Light / Month Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Month Chevron",
    d: "M1.06641 12.2463C1.3584 12.2463 1.59326 12.1447 1.79639 11.9416L6.57617 7.2824C6.84912 7.00945 6.96973 6.74285 6.97607 6.40643C6.97607 6.07635 6.84912 5.79705 6.57617 5.53045L1.80273 0.864922C1.59326 0.668144 1.35205 0.566582 1.06641 0.566582C0.482422 0.566582 0 1.03631 0 1.62029C0 1.91228 0.126953 2.17889 0.342773 2.40105L4.48779 6.41277L0.342773 10.4118C0.120605 10.634 0 10.9006 0 11.1926C0 11.7702 0.482422 12.2463 1.06641 12.2463Z",
    fill: "#ABABAB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthChevron);
export default __webpack_public_path__ + "static/media/Month Chevron.34b74987e3cff0c78408d493ae25d67c.svg";
export { ForwardRef as ReactComponent };